import { render, staticRenderFns } from "./chateau-angelus.vue?vue&type=template&id=3fc783e1&scoped=true"
import script from "./chateau-angelus.vue?vue&type=script&lang=js"
export * from "./chateau-angelus.vue?vue&type=script&lang=js"
import style0 from "./chateau-angelus.vue?vue&type=style&index=0&id=3fc783e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc783e1",
  null
  
)

export default component.exports